import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project-imports
import Search from './Search';
import Profile from './Profile';
import Localization from './Localization';
import MobileSection from './MobileSection';
import FullScreen from './FullScreen';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import DrawerHeader from 'pages/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
    const { i18n, menuOrientation } = useConfig();
    const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const localization = useMemo(() => <Localization />, [i18n]);

    return (
        <>
            {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    px: 2
                }}
            >
                {/* Sezione sinistra */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* {!downLG && <Search />} */}
                </Box>

                {/* Sezione destra */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* <FullScreen /> */}
                    {!downLG && localization}

                    {!downLG && <Profile />}
                    {downLG && <MobileSection />}
                </Box>
            </Box>
        </>
    );
}
